// extracted by mini-css-extract-plugin
export default {"recommendation":"Recommendation_recommendation__PHGDz","list":"Recommendation_list__J5Vdq"};